import { render } from "./ModalContentConfirm.vue?vue&type=template&id=761f438c&scoped=true"
import script from "./ModalContentConfirm.vue?vue&type=script&lang=js"
export * from "./ModalContentConfirm.vue?vue&type=script&lang=js"

import "./ModalContentConfirm.vue?vue&type=style&index=0&id=761f438c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761f438c"]])

export default __exports__